import React, { useCallback, useEffect } from "react";
import { createStyles, makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => createStyles({
  frame: {
    margin: 'auto',
    width: '90%',
    minWidth: '300px',
    maxWidth: '900px',
    height: '50vw',
    minHeight: '200px',
    maxHeight: '480px'
  },
  wrapper: {
    width: '100%',
    textAlign: 'center',
  }
}), { name: 'VideoMenu' });

type Props = {
  token: string;        // Required, Video menu token
  player?: string;      // Optional, Additional player address that will be inserted after `player` and before `.pitchhub.com`
                        // e.g. "dev" or "staging" (the `-` will be added automatically). Leave empty for production
  embed?: boolean;      // Optional, `true` to use embedded JavaScript, `false` to use `iframe`
};

/**
 * Determines the video menu content
 *
 * Kept this as a class instead of a functional component because:
 * - The Video Menu JS `<script>` node needs to be manually generated and inserted into the DOM so that the JS is loaded
 *     Simply returning `<script>` from render does not actually load the JS file.
 * - the Video Menu JavaScript is not React code and it updates the DOM.
 * - the `componentDidUpdate()` function needs to return `false` in order to avoid React overwriting the DOM
 *   which the Video Menu JS has created
 *
 */
const VideoMenu = ({ token, player='', embed = false } : Props) => {
  const classes = useStyles();

  const calculatePlayerUrl = useCallback(() => {
    const playerContext = (player && player.length > 0 ) ? ( '-' + player ) : '';
    return `https://player${playerContext}.pitchhub.com/en/public/player/${(embed? 'embed' : 'iframe' )}/${token}`;
  }, [token, embed, player]);

  useEffect(() => {
    if ( embed && token ) {
      // Append the script directly into the DOM
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = calculatePlayerUrl();
      document.body.appendChild(script);
    }
  }, [token, embed, calculatePlayerUrl]);

  if( embed && token){
    return <div id='video_menu' />;
  }

  if(token){
    return (
      <div className={classes.wrapper}>
        <iframe
          src={calculatePlayerUrl()}
          frameBorder={'0'}
          allowFullScreen={true}
          title={'Video menu'}
          className={classes.frame}
          allow={"autoplay"}
        />
      </div>
    );
  }

  return null;
};

export default VideoMenu;

